import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sunatRespuesta',
})
export class SunatRespuestaPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return '';

    // Normalizar JSON si viene como string
    let response: any;
    try {
      response = typeof value === 'string' ? JSON.parse(value) : value;
    } catch (e) {
      // Si no es JSON válido, retornar el texto como está
      return String(value);
    }

    // Determinar si es modo estándar o payload directo
    const hasSuccess = response.hasOwnProperty('success');
    const payload = response.payload ?? response;

    // Si llega error con success=false
    if (hasSuccess && response.success === false) {
      // Errores del tipo payload.documento
      if (payload?.documento?.length) {
        return `❌ ${payload.documento.join(', ')}`;
      }
      return `❌ ${response.message ?? 'Error desconocido'}`;
    }

    // Si no trae success, asumimos respuesta exitosa SUNAT
    const message = response.message ?? 'SUNAT procesó el comprobante';

    const estado = payload.estado ?? 'DESCONOCIDO';

    // Construimos las líneas
    const lines: string[] = [];

    // Icono según estado
    const icon =
      estado === 'ACEPTADO'
        ? '✔️'
        : estado === 'PENDIENTE'
          ? '⏳'
          : estado === 'RECHAZADO'
            ? '❌'
            : 'ℹ️';

    lines.push(`${icon} ${message}`);

    // Estado visible
    lines.push(`Estado: ${estado}`);

    // Hash
    if (payload.hash) {
      lines.push(`Hash: ${payload.hash.substring(0, 8)}…`);
    }

    // XML
    if (payload.xml) {
      lines.push(`<a href="${payload.xml}" target="_blank">📄 XML</a>`);
    }

    // CDR
    if (payload.cdr) {
      lines.push(`<a href="${payload.cdr}" target="_blank">📑 CDR</a>`);
    } else if (estado !== 'RECHAZADO') {
      // RECHAZADO normalmente sí tiene CDR, pero si no lo dejamos claro
      lines.push(`📑 CDR pendiente`);
    }

    // PDF ticket
    if (payload.pdf?.ticket) {
      lines.push(`<a href="${payload.pdf.ticket}" target="_blank">🧾 Ticket</a>`);
    }

    // PDF A4
    if (payload.pdf?.a4) {
      lines.push(`<a href="${payload.pdf.a4}" target="_blank">📃 A4</a>`);
    }

    return lines.join(' | ');
  }
}
